const ordinals: Record<number, string> = {
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth',
  5: 'Fifth',
  6: 'Sixth',
};

export function semesterLabel(semester: number | undefined | null): string {
  if (semester == null) return '';
  if (semester === 0) return 'Any Semester';
  const word = ordinals[semester];
  return word ? `${word} Semester` : `Semester ${semester}`;
}
